/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { convertDescription } from '../utils/functions';

function CardDescription({ description }) {
    return (
        convertDescription(description) && (
            <div className="scrollbar scrollable overflow-y-auto overflow-x-hidden max-h-[100px] mt-[14px] pb-1">
                <p
                    className="ql-editor text-[8px] sm:text-[10px] md:text-[12px] leading-[12px] text-[#3A3A3A] font-regular opacity-80"
                    dangerouslySetInnerHTML={{
                        __html: convertDescription(description),
                    }}
                />
            </div>
        )
    );
}

export default CardDescription;
